import clsx from 'clsx'
import { TwoColumn } from 'components/core-v2/templates'

import Logo from '../../../assets/logo.svg?react'
import classes from './TwoColumnWithImage.module.scss'

interface Props {
  centered?: boolean
  mainElement: JSX.Element
  showLogo?: boolean
  title: string
  width?: string
}

const LeftColumnWrapper = ({ centered, mainElement, showLogo, title, width }: Props) => (
  <div className={classes.leftColumn}>
    <div
      className={clsx(classes.mainElementWrapper, { 'center-column': centered })}
      style={{ width }}
    >
      <header className={classes.header}>
        {showLogo && <Logo className={classes.logo} />}
        <h1 className={clsx({ 'text-center': centered })}>{title}</h1>
      </header>
      {mainElement}
    </div>
  </div>
)

export const TwoColumnWithImage = ({
  centered = false,
  mainElement,
  showLogo = true,
  title,
  width = '350px'
}: Props) => (
  <TwoColumn
    leftColumn={
      <LeftColumnWrapper
        centered={centered}
        mainElement={mainElement}
        showLogo={showLogo}
        title={title}
        width={width}
      />
    }
    rightColumn={<div aria-hidden className={classes.backgroundImage} />}
  />
)
